module.exports = __webpack_public_path__ + "img/catA.408f5d1b.svg";